import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useEffect, useMemo } from "preact/hooks"
import Checkbox from "./elements/Checkbox"

export default function Facet({ facet, activeFacet, handleFacetChange }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet);

    const open = useMemo(() => (
        handleFacetChange 
            ? activeFacet === facet.id 
            : active
    ), [ handleFacetChange, activeFacet, facet.id, active ]);

    useEffect(() => { // keyboard and outside click handler
        const handleClick = (event) => {
            if(!event.target.closest('.ns-facet')) {
                toggleFacet();
            }
        }

        const handleKeydown = (event) => {
            if(event.key === "Escape") {
                toggleFacet();
            }
        }

        if(activeFacet === facet.id) {
            window.document.addEventListener('click', handleClick);
            window.document.addEventListener('keydown', handleKeydown);
        }
        return () => {
            window.document.removeEventListener('click', handleClick);
            window.document.removeEventListener('keydown', handleKeydown);
        }
    }, [ activeFacet, facet.id ])

    const toggleFacet = () => {
        toggleActive();
        if(handleFacetChange) { // desktop only 1 facet opened at a time
            handleFacetChange(facet.id)
        }
    }

    return (
        <div class="ns-facet relative">
            <button
                class="ns-facet-toggle flex items-center relative"
                type="button"
                data-nosto-element="facet"
                aria-expanded={open}
                aria-label={`${open ? 'Close' : 'Open'} filters list`}
                aria-controls={`ns-${facet.id}-sub-menu`}
                onClick={toggleFacet}
            >
                <span class="h6" id={`ns-${facet.id}-heading`}>{facet.name}</span>
                <div class="ns-facet-toggle-icon">
                    <svg class="ns-plus md:hidden" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation">
                        <path d="M8.49967 3.33203V12.6654M3.83301 7.9987H13.1663" stroke="#2A2829" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    <svg class="ns-minus md:hidden" width="17" height="16" viewBox="0 0 17 16" fill="none" focusable="false" aria-hidden="true" role="presentation" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.83301 8H13.1663" stroke="#2A2829" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    <svg class="ns-chevron hidden md:block" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="presentation" focusable="false">
                        <path d="M4.60207 6.75076C4.21535 6.94998 4.04348 7.3992 4.19582 7.80545C4.25442 7.9617 4.6177 8.34451 6.82863 10.5594C8.27785 12.0125 9.46926 13.1765 9.56692 13.2351C9.78567 13.3679 10.1685 13.3797 10.3872 13.2664C10.4614 13.2273 11.6802 12.0437 13.0904 10.6297C14.9771 8.74686 15.6763 8.0242 15.7232 7.91092C15.7583 7.82498 15.7896 7.65701 15.7857 7.53592C15.7857 7.06717 15.4458 6.71951 14.981 6.70779C14.563 6.69998 14.6489 6.62967 12.231 9.03982L9.9966 11.2703L7.75832 9.03592C6.0552 7.32889 5.48098 6.78201 5.34817 6.72342C5.09817 6.61014 4.85598 6.61795 4.60207 6.75076Z" fill="#2A2829"></path>
                    </svg>
                </div>
            </button>
            <div 
                id={`ns-${facet.id}-sub-menu`}
                class="ns-facet-body"
                aria-hidden={!open}
                aria-labelledby={`ns-${facet.id}-heading`} 
            >
                <div class="hidden md:flex gap-x-2 flex p-2 justify-between items-center border-b-2 border-cream-50">
                    {facet.name}
                </div>
                <ul class="ns-facet-menu p-2" role="menu">
                    {facet.data?.map(value => (
                        <li
                            key={value.value}
                            data-nosto-element="facet-setting"
                            role="menuitem"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                className=''
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
